(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aosky-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGallery = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const items = [...root.querySelectorAll('[data-gallery-item]')];
      const sceneButtons = [...root.querySelectorAll('[data-gallery-scene]')];
      const count = root.querySelector('[data-gallery-count]');
      const empty = root.querySelector('[data-gallery-empty]');
      let activeScene = 'all';

      const update = () => {
        let visible = 0;
        items.forEach((item) => {
          const sceneMatches = activeScene === 'all' || item.dataset.scene === activeScene;
          item.hidden = !sceneMatches;
          if (!item.hidden) visible += 1;
        });
        if (count) count.textContent = `${visible} ${visible === 1 ? root.dataset.countOne : root.dataset.countMany}`;
        if (empty) empty.hidden = visible !== 0;
      };

      const activate = (buttons, current) => {
        buttons.forEach((button) => {
          const active = button === current;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      sceneButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeScene = button.dataset.galleryScene;
          activate(sceneButtons, button);
          update();
        });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.play().catch(() => {});
            else entry.target.pause();
          });
        }, { rootMargin: '120px 0px', threshold: 0.05 });
        root.querySelectorAll('video[autoplay]').forEach((video) => observer.observe(video));
      }

      update();
    };

    document.querySelectorAll('[data-aosky-gallery]').forEach(initializeGallery);
    document.addEventListener('shopify:section:load', (event) => initializeGallery(event.target.querySelector('[data-aosky-gallery]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-sample-selector"]) return;
  try {
    
  class AoskySampleSelector extends HTMLElement {
    connectedCallback() {
      const normalizedUrl = new URL(window.location.href);
      const hadUnsupportedSort = normalizedUrl.searchParams.has('sort_by');
      const hadUnsupportedPage = normalizedUrl.searchParams.has('page');
      normalizedUrl.searchParams.delete('sort_by');
      normalizedUrl.searchParams.delete('page');
      if (hadUnsupportedSort || hadUnsupportedPage) {
        window.location.replace(normalizedUrl.toString());
        return;
      }

      if (this.initialized) {
        this.attachDocumentListeners();
        return;
      }
      this.initialized = true;
      this.limit = Number(this.dataset.limit || 5);
      this.productIds = new Set(JSON.parse(this.dataset.productIds || '[]').map(Number));
      const requestedFilter = new URLSearchParams(window.location.search).get('type');
      const availableFilters = new Set(
        [...this.querySelectorAll('[data-sample-filter]')].map(button => button.dataset.sampleFilter)
      );
      this.activeFilter = availableFilters.has(requestedFilter) ? requestedFilter : 'all';
      this.searchQuery = '';
      this.activeSeries = '';
      this.seriesSelect = this.querySelector('[data-sample-series-select]');
      this.moreDetails = this.querySelector('[data-sample-more]');
      this.moreTrigger = this.querySelector('[data-sample-more-trigger]');
      this.moreLabel = this.querySelector('[data-sample-more-label]');
      this.searchToggle = this.querySelector('[data-sample-search-toggle]');
      this.searchControl = this.querySelector('.sample-selector__search');
      this.searchInput = this.querySelector('[data-sample-search]');
      this.countElement = this.querySelector('[data-sample-count]');
      this.messageElement = this.querySelector('[data-sample-message]');
      this.emptyElement = this.querySelector('[data-sample-empty]');
      this.comingSoonCategories = new Set(
        (this.dataset.comingSoonCategories || '').split(',').map(value => value.trim()).filter(Boolean)
      );
      this.comingSoonElement = this.querySelector('[data-sample-coming-soon]');
      this.comingSoonMessageElement = this.querySelector('[data-sample-coming-soon-message]');
      this.overviewElement = this.querySelector('[data-sample-category-overview]');
      this.groupsElement = this.querySelector('[data-sample-groups]');
      this.reconcileRenderedComingSoonCategories();
      this.dialog = this.querySelector('[data-sample-dialog]');
      this.dialogImage = this.querySelector('[data-sample-dialog-image]');
      this.dialogTitle = this.querySelector('[data-sample-dialog-title]');
      this.querySelectorAll('.sample-selector__grid').forEach(grid => {
        [...grid.querySelectorAll('[data-sort-order]')]
          .sort((firstCard, secondCard) => Number(firstCard.dataset.sortOrder) - Number(secondCard.dataset.sortOrder))
          .forEach(card => grid.append(card));
      });
      this.sortSeriesGroups();
      this.buildSeriesOptions();
      this.addEventListener('click', this.handleClick.bind(this));
      this.searchInput?.addEventListener('input', event => {
        this.searchQuery = event.target.value.trim().toLowerCase();
        this.applyFilters();
      });
      this.seriesSelect?.addEventListener('change', event => this.selectSeries(event.target.value));
      this.searchToggle?.addEventListener('click', () => {
        this.setSearchOpen(this.searchToggle.getAttribute('aria-expanded') !== 'true');
      });
      this.moreDetails?.addEventListener('toggle', () => {
        this.moreTrigger?.setAttribute('aria-expanded', String(this.moreDetails.open));
      });
      this.boundDocumentClick = event => {
        if (this.moreDetails?.open && !this.moreDetails.contains(event.target)) this.closeMore();
      };
      this.boundKeydown = event => {
        if (event.key === 'Escape') this.handleDisclosureEscape(event);
      };
      this.attachDocumentListeners();
      this.dialog?.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.setActiveFilter(this.activeFilter);
      this.applyFilters();
      this.refreshCart();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundDocumentClick);
      document.removeEventListener('keydown', this.boundKeydown);
      this.documentListenersAttached = false;
    }

    attachDocumentListeners() {
      if (this.documentListenersAttached) return;
      document.addEventListener('click', this.boundDocumentClick);
      document.addEventListener('keydown', this.boundKeydown);
      this.documentListenersAttached = true;
    }

    setActiveFilter(filterValue, updateUrl = false) {
      this.activeFilter = filterValue;
      this.querySelectorAll('.sample-selector__filter[data-sample-filter]').forEach(button => {
        const active = button.dataset.sampleFilter === filterValue;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (updateUrl) this.syncFilterUrl(filterValue);
      this.updateMobileCategoryState();
    }

    buildSeriesOptions() {
      if (!this.seriesSelect || !this.groupsElement) return;
      const groups = [...this.groupsElement.querySelectorAll('[data-sample-group]')];
      groups.forEach(group => {
        const seriesName = (group.dataset.seriesName || '').trim();
        if (!seriesName) return;
        const seriesLabel = (group.dataset.seriesLabel || seriesName).trim();
        const option = document.createElement('option');
        option.value = seriesName;
        option.textContent = seriesLabel;
        this.seriesSelect.append(option);
      });
    }

    selectCategory(filterValue, updateUrl = true) {
      this.activeSeries = '';
      if (this.seriesSelect) this.seriesSelect.value = '';
      if (updateUrl) {
        this.setActiveFilter(filterValue, true);
      } else {
        this.setActiveFilter(filterValue);
      }
      this.closeMore();
      this.applyFilters();
    }

    selectSeries(seriesName) {
      this.activeSeries = seriesName;
      if (!seriesName) {
        this.applyFilters();
        return;
      }
      const group = [...this.querySelectorAll('[data-sample-group]')]
        .find(group => group.dataset.seriesName === seriesName);
      if (!group) {
        this.activeSeries = '';
        if (this.seriesSelect) this.seriesSelect.value = '';
        this.applyFilters();
        return;
      }
      this.setActiveFilter(group.dataset.category, true);
      this.closeMore();
      this.applyFilters();
    }

    closeMore(restoreFocus = false) {
      const wasOpen = Boolean(this.moreDetails?.open);
      if (this.moreDetails) this.moreDetails.open = false;
      if (restoreFocus && wasOpen) this.moreTrigger?.focus();
    }

    handleDisclosureEscape(event) {
      if (event.key !== 'Escape') return;

      const moreHasFocus = this.moreDetails?.open && this.moreDetails.contains(event.target);
      if (moreHasFocus) {
        event.preventDefault();
        this.closeMore(true);
        return;
      }

      const searchIsOpen = this.searchToggle?.getAttribute('aria-expanded') === 'true';
      const searchHasFocus = this.searchControl?.contains(event.target) || event.target === this.searchToggle;
      if (searchIsOpen && searchHasFocus) {
        event.preventDefault();
        this.setSearchOpen(false);
        this.searchToggle.focus();
      }
    }

    updateMobileCategoryState() {
      if (!this.moreDetails || !this.moreLabel) return;
      const option = this.querySelector(
        `[data-sample-more-option][data-sample-filter="${this.activeFilter}"]`
      );
      this.moreDetails.classList.toggle('is-active', Boolean(option));
      this.moreLabel.textContent = option?.dataset.mobileLabel || this.dataset.moreLabel;
    }

    setSearchOpen(open) {
      if (!this.searchToggle || !this.searchControl) return;
      this.searchToggle.setAttribute('aria-expanded', String(open));
      this.searchToggle.setAttribute(
        'aria-label',
        open ? this.dataset.closeSearchLabel : this.dataset.openSearchLabel
      );
      this.searchControl.classList.toggle('is-open', open);
      if (open) {
        this.searchInput?.focus();
        return;
      }
      this.searchQuery = '';
      if (this.searchInput) this.searchInput.value = '';
      this.applyFilters();
    }

    syncFilterUrl(filterValue) {
      const url = new URL(window.location.href);
      if (filterValue === 'all') {
        url.searchParams.delete('type');
      } else {
        url.searchParams.set('type', filterValue);
      }
      window.history.replaceState({}, '', url);
    }

    collectionOrder(group) {
      const rawIndex = group.dataset.collectionIndex;
      if (rawIndex === undefined || rawIndex === '') return Number.MAX_SAFE_INTEGER;

      const collectionIndex = Number(rawIndex);
      return Number.isFinite(collectionIndex) ? collectionIndex : Number.MAX_SAFE_INTEGER;
    }

    numericRank(group, key) {
      const rawRank = group.dataset[key];
      if (rawRank === undefined || rawRank === null || String(rawRank).trim() === '') return 9999;

      const rank = Number(rawRank);
      return Number.isFinite(rank) ? rank : 9999;
    }

    sortSeriesGroups() {
      if (!this.groupsElement) return;
      const categoryRank = new Map([
        ['roller', 0],
        ['zebra', 1],
        ['roman', 2],
        ['woven', 3],
        ['cellular', 4],
        ['shangri-la', 5]
      ]);

      [...this.groupsElement.querySelectorAll('[data-sample-group]')]
        .sort((firstGroup, secondGroup) => {
          const categoryDifference =
            (categoryRank.get(firstGroup.dataset.category) ?? 99) -
            (categoryRank.get(secondGroup.dataset.category) ?? 99);
          if (categoryDifference) return categoryDifference;

          const firstHasSales = firstGroup.dataset.sampleHasSales === 'true';
          const secondHasSales = secondGroup.dataset.sampleHasSales === 'true';
          if (firstHasSales !== secondHasSales) return firstHasSales ? -1 : 1;

          const rankKey = firstHasSales ? 'sampleSalesRank' : 'productSalesRank';
          const rankDifference =
            this.numericRank(firstGroup, rankKey) - this.numericRank(secondGroup, rankKey);
          if (rankDifference) return rankDifference;

          const firstOrder = this.collectionOrder(firstGroup);
          const secondOrder = this.collectionOrder(secondGroup);
          if (firstOrder !== secondOrder) return firstOrder - secondOrder;

          return (firstGroup.dataset.productHandle || '').localeCompare(
            secondGroup.dataset.productHandle || '',
            undefined,
            { numeric: true, sensitivity: 'base' }
          );
        })
        .forEach(group => this.groupsElement.append(group));
    }

    handleClick(event) {
      const filter = event.target.closest('[data-sample-filter]');
      const categoryCard = event.target.closest('[data-category-filter]');
      if (filter || categoryCard) {
        const filterValue = filter?.dataset.sampleFilter || categoryCard.dataset.categoryFilter;
        const restoreMoreFocus = Boolean(
          filter?.matches('[data-sample-more-option]') && this.moreDetails?.open
        );
        this.selectCategory(filterValue, true);
        if (restoreMoreFocus) this.moreTrigger?.focus();
        return;
      }

      const preview = event.target.closest('[data-sample-preview]');
      if (preview) {
        if (!preview.dataset.previewSrc || !this.dialog) return;
        this.dialogImage.src = preview.dataset.previewSrc;
        this.dialogImage.alt = preview.dataset.previewAlt;
        this.dialogImage.hidden = false;
        this.dialogTitle.textContent = preview.dataset.previewTitle;
        this.dialog.showModal();
        return;
      }

      const swap = event.target.closest('[data-sample-swap]');
      if (swap) {
        const stage = swap.closest('[data-sample-image-stage]');
        const previewButton = stage?.querySelector('[data-sample-preview]');
        const mainImage = stage?.querySelector('.sample-selector__main-image');
        const thumbnailImage = swap.querySelector('img');
        if (!previewButton || !mainImage || !thumbnailImage || !swap.dataset.swapSrc) return;

        const currentSrc = mainImage.currentSrc || mainImage.src;
        const currentPreviewSrc = previewButton.dataset.previewSrc;
        const currentAlt = mainImage.alt;

        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = swap.dataset.swapSrc;
        mainImage.alt = swap.dataset.swapAlt;

        thumbnailImage.removeAttribute('srcset');
        thumbnailImage.removeAttribute('sizes');
        thumbnailImage.src = currentSrc;
        thumbnailImage.alt = currentAlt;

        previewButton.dataset.previewSrc = swap.dataset.swapPreviewSrc || swap.dataset.swapSrc;
        previewButton.dataset.previewAlt = swap.dataset.swapAlt;
        swap.dataset.swapSrc = currentSrc;
        swap.dataset.swapPreviewSrc = currentPreviewSrc;
        swap.dataset.swapAlt = currentAlt;
        return;
      }

      if (event.target.closest('[data-sample-dialog-close]')) {
        this.dialog?.close();
        return;
      }

      const action = event.target.closest('[data-sample-action]');
      if (action) this.updateSample(action);
    }

    isComingSoonCategory(category) {
      return category !== 'all' && this.comingSoonCategories.has(category);
    }

    reconcileRenderedComingSoonCategories() {
      const reconcilableCategories = new Set(['roman', 'woven']);
      const groups = [...this.querySelectorAll('[data-sample-group]')];
      reconcilableCategories.forEach(category => {
        const hasRenderedCard = groups.some(group =>
          group.dataset.category === category && Boolean(group.querySelector('[data-sample-card]'))
        );
        if (!hasRenderedCard) return;

        this.comingSoonCategories.delete(category);
        const overviewCard = this.querySelector(
          `[data-sample-category-card][data-category-filter="${category}"]`
        );
        if (!overviewCard) return;
        overviewCard.dataset.categoryComingSoon = 'false';
        const badge = overviewCard.querySelector('[data-sample-category-badge]');
        if (badge) badge.hidden = true;
      });
    }

    updateComingSoonState() {
      const isComingSoon = this.isComingSoonCategory(this.activeFilter);
      if (this.comingSoonElement) this.comingSoonElement.hidden = !isComingSoon;
      if (isComingSoon && this.comingSoonMessageElement) {
        const activeButton = this.querySelector(`[data-sample-filter="${this.activeFilter}"]`);
        const category = activeButton?.textContent.trim() || this.activeFilter;
        this.comingSoonMessageElement.textContent =
          (this.dataset.comingSoonMessageTemplate || '').replace('[category]', category);
      }
      return isComingSoon;
    }

    applyFilters() {
      const categoryComingSoon = this.updateComingSoonState();
      const showOverview = this.activeFilter === 'all' && !this.activeSeries && !this.searchQuery;
      if (this.overviewElement) this.overviewElement.hidden = !showOverview;

      let visibleGroups = 0;
      this.querySelectorAll('[data-sample-group]').forEach(group => {
        const categoryMatches = this.activeFilter === 'all' || group.dataset.category === this.activeFilter;
        const seriesMatches = !this.activeSeries || group.dataset.seriesName === this.activeSeries;
        const groupComingSoon = this.isComingSoonCategory(group.dataset.category);
        let visibleCards = 0;
        group.querySelectorAll('[data-sample-card]').forEach(card => {
          const text = card.dataset.searchText || '';
          const searchMatches = !this.searchQuery || text.includes(this.searchQuery);
          card.hidden = showOverview || categoryComingSoon || groupComingSoon || !categoryMatches || !seriesMatches || !searchMatches;
          if (!card.hidden) visibleCards += 1;
        });
        group.hidden = showOverview || categoryComingSoon || groupComingSoon || !categoryMatches || !seriesMatches || visibleCards === 0;
        if (!group.hidden) visibleGroups += 1;
      });
      if (this.emptyElement) this.emptyElement.hidden = showOverview || categoryComingSoon || visibleGroups > 0;
    }

    async updateSample(button) {
      if (button.dataset.busy === 'true') return;
      const selected = button.dataset.selected === 'true';
      if (!selected && this.selectedCount >= this.limit) {
        this.showMessage(this.dataset.limitMessage);
        return;
      }

      button.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = this.dataset.loadingLabel;

      try {
        const endpoint = selected ? 'cart/change.js' : 'cart/add.js';
        const payload = selected
          ? { id: button.dataset.lineKey, quantity: 0 }
          : {
              items: [{
                id: Number(button.dataset.variantId),
                quantity: 1,
                properties: {
                  '_AOSKY Sample': 'true',
                  'Sample Series': button.dataset.sampleSeries,
                  'Fabric': button.dataset.sampleName,
                  'Fabric Code': button.dataset.sampleCode
                }
              }]
            };
        const response = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Cart update failed');
        this.syncThemeCart(!selected);
        this.showMessage('');
      } catch (error) {
        this.showMessage(this.dataset.errorMessage);
      } finally {
        button.dataset.busy = 'false';
        await this.refreshCart().catch(() => {});
      }
    }

    async refreshCart() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      const sampleItems = cart.items.filter(item => this.productIds.has(Number(item.product_id)));
      const selectedByCode = new Map();
      sampleItems.forEach(item => {
        const code = item.properties?.['Fabric Code'];
        if (code) selectedByCode.set(code, item.key);
      });
      this.selectedCount = sampleItems.reduce((total, item) => total + Number(item.quantity || 0), 0);

      this.querySelectorAll('[data-sample-action]').forEach(button => {
        const lineKey = selectedByCode.get(button.dataset.sampleCode) || '';
        const selected = Boolean(lineKey);
        const unavailable = button.dataset.available === 'false';
        button.dataset.selected = String(selected);
        button.dataset.lineKey = lineKey;
        button.classList.toggle('is-selected', selected);
        button.textContent = unavailable ? this.dataset.soldOutLabel : selected ? this.dataset.removeLabel : this.dataset.addLabel;
        button.disabled = unavailable || (!selected && this.selectedCount >= this.limit);
      });

      if (this.countElement) {
        this.countElement.textContent = this.dataset.countTemplate.replace('[count]', String(this.selectedCount));
      }
    }

    syncThemeCart(openCart) {
      if (!window.Alpine) return;
      const miniCart = window.Alpine.store('xMiniCart');
      miniCart?.reLoad();
      if (openCart) miniCart?.openCart();
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    }

    showMessage(message) {
      if (!this.messageElement) return;
      this.messageElement.textContent = message;
      this.messageElement.hidden = !message;
    }
  }

  if (!customElements.get('sample-selector')) customElements.define('sample-selector', AoskySampleSelector);

  } catch(e) { console.error(e); }
})();
})();
